export interface IKontoaktDto {
  inhalt?: string | null;
  bezeichnung?: string | null;
}

export interface IAdresseDto {
  plz?: string | null;
  ort?: string | null;
}

export interface IBankverbindungDto {
  iban?: string | null;
  bic?: string | null;
  finanzinstitut?: string | null;
  kontoinhaber?: string | null;
}

export interface IFinanzamtDto {
  id?: string | null;
  name?: string | null;

  adressen?: IAdresseDto[] | null;
  bankverbindungen?: IBankverbindungDto[] | null;

  oeffnungszeiten?: string[] | null;
  bemerkungen?: string[] | null;
}

export class AdresseDto implements IAdresseDto {
  constructor(public plz?: string | null, public ort?: string | null) {}
}

export class BankverbindungDto implements IBankverbindungDto {
  constructor(
    public iban?: string | null,
    public bic?: string | null,
    public finanzinstitut?: string | null,
    public kontoinhaber?: string | null
  ) {}
}

export class FinanzamtDto implements IFinanzamtDto {
  constructor(
    public id?: string | null,
    public name?: string | null,

    public adressen?: IAdresseDto[] | null,
    public kontakte?: IKontoaktDto[] | null,
    public bankverbindungen?: IBankverbindungDto[] | null,

    public oeffnungszeiten?: string[] | null,
    public bemerkungen?: string[] | null
  ) {}
}
